export default __webpack_public_path__ + "static/gantry-c3b432e695c894bdda080c084bb29073.png";